export const modalKey = Symbol.for('modal');
export const alertsKey = Symbol.for('alerts');
